import React from 'react'
import AdminForgotPasswordLayer from './AdminForgotPasswordLayer';

const AdminForgotPasswordPage = () => {
  return (
    <>
      {/* ForgotPasswordLayer */}
      <AdminForgotPasswordLayer />
    </>
  );
}

export default AdminForgotPasswordPage